import { z } from 'zod'

export const FacetFilter = z.record(
	z.union([
		z.boolean(),
		z.string(),
		z.tuple([z.number().nullable(), z.number().nullable()]),
		z.tuple([z.string(), z.boolean()]),
	]),
)
export type FacetFilter = z.infer<typeof FacetFilter>
